/**
 * アコーディオンイベント
 * 「.js__accordion」に対して処理をする
 * data-target data-toggleclass の設定が必要
 */
import { functions } from './functions';

export module AccordionActionModule {
  export class Service {
    constructor(language?: string) {
      document.addEventListener('readCompleteAction', () => {
        Service.toggleAction();
      });
    }

    /**
     * アコーディオン処理
     */
    public static toggleAction() {
      let $elements = document.getElementsByClassName('js__accordion');
      if ($elements && $elements.length) {
        for (let $i = 0; $i < $elements.length; $i++) {
          let $element = $elements[$i];
          $element.addEventListener('click', () => {
            let $target: string | null = $element.getAttribute('data-target');
            let $toggleclass: string | null = $element.getAttribute('data-accordionclass');
            if ($target && $toggleclass) {
              let $targetElement = document.querySelector($target);
              $element.classList.toggle($toggleclass);
              if ($targetElement) {
                $targetElement.classList.toggle($toggleclass);
                functions.slideToggle($targetElement as HTMLElement);
              }
            }
          });
        }
      }
    }
  }
}